// extracted by mini-css-extract-plugin
export default {"topProgress":"unit-page_topProgress__GLZ-s"};